import { api } from '@/lib/api/client';
import type { CreateFeedbackPayload } from '@shared/types/entities';

export interface CreateFeedbackResponse {
  ok: true;
  id: number;
  message: string;
}

/** Envoi d'un feedback (utilisateur connecté — token JWT injecté par le client). */
export async function sendFeedbackApi(payload: CreateFeedbackPayload): Promise<CreateFeedbackResponse> {
  return api.post('/feedback', payload);
}
